import $ from 'jquery'


export default () => {
  const formElement = $('#enduser-tds-form')
  if (formElement == null || formElement[0] == null) return

  formElement.find('button.btn').click((e) => {
    const values = formElement.find('input[type="number"]')
                              .map(function(){ return $(this).val() })
                              .toArray()
                              .map((t) => parseInt(t))
                              .filter((t) => t == 0)

    if (values.length > 0) {
      $('#tds-select-error').show()
      e.preventDefault()
    }
  })

  // console.log('hello there')
}
